import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['spinner', 'text', 'icon']

  declare readonly spinnerTarget: HTMLElement
  declare readonly textTarget: HTMLElement
  declare readonly iconTarget: HTMLElement

  async start (event: Event): Promise<void> {
    event.preventDefault()

    const button = this.element as HTMLAnchorElement
    const url = button.href

    this.toggleLoading(true)

    try {
      const response = await fetch(url)
      if (!response.ok) throw new Error('Download failed')

      const blob = await response.blob()
      const filename = this.extractFilename(response.headers) ?? 'report.pdf'

      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = filename
      document.body.appendChild(link)
      link.click()
      link.remove()
      URL.revokeObjectURL(link.href)
    } finally {
      this.toggleLoading(false)
    }
  }

  toggleLoading (isLoading: boolean): void {
    this.spinnerTarget.classList.toggle('hidden', !isLoading)
    this.textTarget.classList.toggle('opacity-50', isLoading)
    this.element.classList.toggle('pointer-events-none', isLoading)
    this.element.classList.toggle('opacity-60', isLoading)
    this.iconTarget.classList.toggle('hidden', isLoading)
  }

  extractFilename (headers: Headers): string {
    const disposition = headers.get('Content-Disposition') ?? ''
    const match = disposition.match(/filename="?([^"]+)"?/)
    return match?.[1] ?? 'report.pdf'
  }
}
